import classNames from "classnames";

import { ReactComponent as IconTopDonation } from "../../assets/ic-top-donation.svg";
import { ReactComponent as IconDonation } from "../../assets/ic-donation.svg";

import styles from "./index.module.scss";

const FollowerIcon = ({
  isPaid,
  isFollowers,
  isSupporter,
  hideDonationIcons,
  isFirst,
  isNotOnlyBadge,
  noMargin,
}) => {
  const className = classNames(
    "flex-shrink-0",
    styles.icon,
    isFirst && (isFollowers || isSupporter) && styles.top,
    isNotOnlyBadge && styles.notOnlyBadge,
    noMargin && styles.withoutMargin,
  );

  if (isPaid && isFirst && !hideDonationIcons) {
    if (isFollowers) return <IconTopDonation className={className} />;
    if (isSupporter) return <IconDonation className={className} />;
  }

  if (isPaid && !hideDonationIcons) {
    return <IconDonation className={className} />;
  }

  return null;
};

export default FollowerIcon;
